document.addEventListener('DOMContentLoaded', function() {
  const wishlistButtons = document.querySelectorAll('.button-wishlist');

  wishlistButtons.forEach(button => {
    button.addEventListener('click', function() {
      const productHandle = this.getAttribute('data-product-handle');
      let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

      if (wishlist.includes(productHandle)) {
        wishlist = wishlist.filter(item => item !== productHandle);
        this.classList.remove('active');
      } else {
        wishlist.push(productHandle);
        this.classList.add('active');
      }

      localStorage.setItem('wishlist', JSON.stringify(wishlist));
    });
  });

  // Initialize wishlist state
  const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  wishlistButtons.forEach(button => {
    const productHandle = button.getAttribute('data-product-handle');
    if (wishlist.includes(productHandle)) {
      button.classList.add('active');
    }
  });
});


